// extracted by mini-css-extract-plugin
export default {"textBreak":"DomainBundleDetailRow-textBreak_KPVK5"};